import { makeAutoObservable } from 'mobx'

import { TYPE_TIMER, TYPE_TIMER_START, TimerStore } from './model'

const EACH_INTERVAL = 1000

const MINUTEST_MULTIPLY_SECONDS = 60

class TimerForm {
  timerStore: TimerStore | Partial<TimerStore> = {}

  constructor() {
    makeAutoObservable(this)
  }

  startTimer(timerType: TYPE_TIMER) {
    if (!this.timerStore?.[timerType] || !this.timerStore?.[timerType]?.timer) {
      this.timerStore[timerType] = {
        timer: TYPE_TIMER_START[timerType] * MINUTEST_MULTIPLY_SECONDS,
        isRunning: true,
        timerID: undefined,
      }
    }

    this.timerStore[timerType]!.timerID = setInterval(() => {
      if (this.timerStore[timerType]) {
        if (this.timerStore[timerType]!.timer === 0) {
          this.onTimerOver(timerType)

          return
        }

        this.timerStore[timerType]!.timer =
          (this.timerStore[timerType]!.timer || 1) - 1
      }
    }, EACH_INTERVAL)
  }

  getTimerData(timerType: TYPE_TIMER) {
    if (!this.timerStore) {
      return {
        isRunning: false,
      }
    }

    return this.timerStore[timerType]
  }

  onResetTimer(timerType: TYPE_TIMER) {
    if (!this.timerStore[timerType]) return

    clearInterval(this.timerStore[timerType]!.timerID)

    this.timerStore[timerType] = {}
  }

  onTimerOver(timerType: TYPE_TIMER) {
    if (!this.timerStore[timerType]) return

    this.timerStore[timerType]!.isRunning = false

    if (this.timerStore[timerType]!.timerID) {
      clearInterval(this.timerStore[timerType]!.timerID)
    }
  }
}

export default new TimerForm()
